import {useEffect, EffectCallback, DependencyList, useRef} from "react";

// This hook gets called only when the dependencies change but not during initial render
export const useNonInitialEffect = (effect: EffectCallback, deps?: DependencyList): void => {
  const initialRender = useRef(true);

  useEffect(() => {
    let effectReturns: ReturnType<EffectCallback> = () => {
      return;
    };

    if (initialRender.current) {
      initialRender.current = false;
    } else {
      effectReturns = effect();
    }

    return effectReturns;
  }, deps);
};
